import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: "",
  username: "",
  email: "",
  role: "",
  businessName: "",
  businessPhone: "",
  ntn: "",
  salesTaxNumber: "",
  licenceNumber: "",
  invoiceType: "",
  cnic: "",
  province: "",
  address: "",
  branchId: "",
  branch: null, // { id, name, location }
  selectedBranchId: "", // admin only: which branch is selected for stats/products/invoices
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const {
        id,
        username,
        email,
        role,
        businessName,
        businessPhone,
        ntn,
        salesTaxNumber,
        licenceNumber,
        invoiceType,
        cnic,
        province,
        address,
        branchId,
        branch,
      } = action.payload;

      state.id = id || "";
      state.username = username || "";
      state.email = email || "";
      state.role = role ?? "admin";
      state.businessName = businessName || "";
      state.businessPhone = businessPhone || "";
      state.ntn = ntn || "";
      state.salesTaxNumber = salesTaxNumber || "";
      state.licenceNumber = licenceNumber || "";
      state.invoiceType = invoiceType || "";
      state.cnic = cnic || "";
      state.province = province || "";
      state.address = address || "";
      state.branchId = branchId ?? "";
      state.branch = branch ?? null;
    },

    setSelectedBranch: (state, action) => {
      state.selectedBranchId = action.payload ?? "";
    },

    logoutUser: (state) => {
      state.id = "";
      state.username = "";
      state.email = "";
      state.role = "";
      state.businessName = "";
      state.businessPhone = "";
      state.ntn = "";
      state.salesTaxNumber = "";
      state.licenceNumber = "";
      state.invoiceType = "";
      state.cnic = "";
      state.province = "";
      state.address = "";
      state.branchId = "";
      state.branch = null;
      state.selectedBranchId = "";
    },
  },
});

export const { setUser, setSelectedBranch, logoutUser } = userSlice.actions;
export default userSlice.reducer;
